// this page created by akash-ak
import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useLazyGetResourceQuery } from '../../../../store/api/contactapi'
const Table3 = ({ setselected_item_data, po_status, formData, onInputChange, doctypeList, refetch }) => {


    const createNewRow = () => ({
        Link_Document_Type: "",
        Link_Name: '',
        Link_Title: "",

    });
    const [fetchResource, { data, isLoading, error }] = useLazyGetResourceQuery();
    const fetchData = async (resourceName: string) => {
        try {
            const response = await fetchResource(resourceName).unwrap();
            return response;
        } catch (err) {
            console.error(`Error fetching ${resourceName}:`, err);
            throw err;
        }
    };
    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [item_list, setitem_list] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rows, setRows] = useState([createNewRow()]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [search_input, setsearch_input] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdown_two, setShowDropdown_two] = useState(false);


    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const [item_list_two, setitem_list_two] = useState([]);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allRowIndices = rows.map((_, index) => index);
            setSelectedRows(allRowIndices);
        } else {
            setSelectedRows([]);
        }
    };

    const getItemdata = async (itemname) => {
        const updatedRows = [...rows];
        const call = updatedRows[itemname]["Link_Document_Type"]
        if (!call) {
            console.log("Skipping API call - itemname is empty");
            return; 
        }
        try {
            const resr = await fetchData(call);
            setitem_list_two(resr.data);
        } catch (error) {
            console.error("Error in getItemdata:", error);
            throw error;
        }
    };

    const updateRow = (index, field, value) => {
        console.log(index, field, value, "index, field, value");

        const updatedRows = [...rows];

        // Update the specified field
        updatedRows[index][field] = value;

        if (field === "Link_Name") {
            updatedRows[index]["Link_Title"] = value;
        }
        if (field === "Link_Document_Type" && updatedRows[index]["Link_Name"]) {
            updatedRows[index]["Link_Name"] = "";
            updatedRows[index]["Link_Title"] = "";
        }

        setRows(updatedRows);
        setselected_item_data(updatedRows);
    };
    const toggleRowSelection = (index) => {
        setSelectedRows((prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]);
    };

    const handleAddRow = () => {
        const newRows = [...rows, createNewRow()];
        setRows(newRows);
        setselected_item_data(newRows);
        const lastPage = Math.ceil(newRows.length / rowsPerPage);
        if (currentPage !== lastPage) {
            setCurrentPage(lastPage);
        }
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setselected_item_data(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) {
            setCurrentPage(lastPage);
        }
    };

    useEffect(() => {

        setitem_list(doctypeList)

    }, [doctypeList]);
    useEffect(() => {
        const dropdown = dropdownRef.current;
        if (!dropdown) return;
        const handleScroll = () => {
            if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
                const newOffset = offset + 20;
                setOffset(newOffset);
            }
        };
        dropdown.addEventListener("scroll", handleScroll);
        return () => dropdown.removeEventListener("scroll", handleScroll);
    }, [offset, hasMore, search_input]);

    useEffect(() => {
        const cols = tableRef.current.querySelectorAll("th");
        cols.forEach((col) => {
            const resizer = document.createElement("div");
            resizer.className = "resizer";
            col.appendChild(resizer);

            let x = 0;
            let w = 0;

            const onMouseDown = (e) => {
                x = e.clientX;
                w = col.offsetWidth;

                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
            };

            const onMouseMove = (e) => {
                const dx = e.clientX - x;
                col.style.width = `${w + dx}px`;
            };

            const onMouseUp = () => {
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            };

            resizer.addEventListener("mousedown", onMouseDown);
        });
    }, []);

    return (
        <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
            <div className="col-12">
                <p className="boxLabel m-0">Reference</p>
            </div>
            <div className="">
                <table className="table table-bordered mb-1" ref={tableRef}>
                    <thead className="tableHead1">
                        <tr>
                            {["Action", "S.No", "Link Document Type", "Link Name", "Link Title", "Settings"].map((title, i) => {
                                const defaultWidths = {
                                    "Action": "20px",
                                    "S.No": "20px",
                                    "Link Document Type": "210px",
                                    "Link Name": "80px",
                                    "Link Title": "100px",
                                    "Settings": "50px"

                                };

                                return (
                                    <th
                                        key={i}
                                        style={{
                                            fontSize: '7px',
                                            position: "relative",
                                            textAlign: ["Action", "S.No", "Settings", "Is Primary Phone", "Is Primary Mobile"].includes(title)
                                                ? "center"
                                                : "left",
                                            width: defaultWidths[title] || "150px",
                                            minWidth: defaultWidths[title] || "150px",
                                        }}
                                    >
                                        {title === "Settings" ? (
                                            <GetIcon iconName="IoSettingsOutline"
                                                style={{ fontSize: '15px' }}
                                                size={15} />
                                        ) : title === "Action" ? (
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                style={{
                                                    backgroundColor: isAllSelected ? "#270b79" : "",
                                                    borderColor: isAllSelected ? "#270b79" : "",
                                                    fontSize: '15px'
                                                }}
                                                checked={isAllSelected}
                                                onChange={handleSelectAll}
                                            />
                                        ) : (
                                            title
                                        )}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>

                    <tbody>
                        {currentRows.map((row, index) => {
                            const globalIndex = indexOfFirstRow + index;
                            return (
                                <tr key={globalIndex}>
                                    <td className="p-0" style={{ cursor: 'pointer' }}>
                                        <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                                            {selectedRows.includes(globalIndex) ? (
                                                <span onClick={() => toggleRowSelection(globalIndex)}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                                                        checked
                                                    />
                                                </span>
                                            ) : (
                                                <span onClick={() => toggleRowSelection(globalIndex)}>
                                                    <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                                                </span>
                                            )}
                                        </p>
                                    </td>
                                    <td style={{
                                        textAlign: "center",
                                        fontSize: '0.8rem',
                                        padding: '0.5rem'
                                    }}>
                                        {globalIndex + 1}
                                    </td>
                                    <td className="p-0 d-flex justify-content-center" style={{ position: "relative", border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'Link Document Type' ? '0.3px solid #270b79' : '' }}>
                                        <input
                                            type="text"
                                            className="form-control tableinput noborder"
                                            style={{ fontSize: '0.8rem' }}
                                            onFocus={() => { setShowDropdown(globalIndex); setFocusedCell({ rowIndex: globalIndex, field: 'Link Document Type' }) }}
                                            onBlur={() => { setTimeout(() => setShowDropdown(false), 300) }}
                                            onChange={(e) => {
                                                setsearch_input(e.target.value);
                                                setOffset(0);
                                                // getItemdata(0, e.target.value);
                                                updateRow(globalIndex, "Link_Document_Type", e.target.value);
                                            }}
                                            value={row.Link_Document_Type || row.Link_Document_Type}
                                        />
                                        <div
                                            ref={dropdownRef}
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                right: 0,
                                                maxHeight: showDropdown === globalIndex ? "200px" : "0",
                                                display: showDropdown === globalIndex ? '' : 'none',
                                                overflowY: "auto",
                                                background: "white",
                                                border: showDropdown === globalIndex ? "1px solid #ccc" : "",
                                                zIndex: 10,
                                            }}
                                        >
                                            {item_list.map((item, idx) => (
                                                <div key={idx}
                                                    className="text-start"
                                                    onClick={() => {
                                                        // updateRow(globalIndex, "Link_Document_Type", item);
                                                        updateRow(globalIndex, "Link_Document_Type", item.name);
                                                        setsearch_input("");
                                                        setShowDropdown(false);
                                                        // getItemdata(item.name)
                                                    }}
                                                    style={{
                                                        padding: "8px",
                                                        cursor: "pointer",
                                                        borderBottom: "1px solid #eee",
                                                    }}
                                                >
                                                    <p className="m-0">
                                                        {item.name}
                                                    </p>
                                                    {/* <div style={{ fontSize: '10px' }}>
                                                        {item?.name}, {item?.name}
                                                    </div> */}
                                                </div>
                                            ))}
                                            {!hasMore && item_list.length === 0 && (
                                                <div style={{ padding: "8px", color: "#888" }}>No results</div>
                                            )}
                                        </div>
                                    </td>
                                    {/* testtwo */}

                                    {/* testtwo end */}
                                    <td className="p-0" style={{ position: "relative", border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'Link Name' ? '0.3px solid #270b79' : '' }}>
                                        <input
                                            type="text"
                                            className="form-control tableinput noborder"
                                            style={{ fontSize: '0.8rem' }}
                                            onFocus={() => {
                                                setShowDropdown_two(globalIndex);
                                                setFocusedCell({ rowIndex: globalIndex, field: 'Link Name' });
                                                getItemdata(globalIndex);  // Add this line
                                            }} onBlur={() => { setTimeout(() => setShowDropdown(false), 300) }}
                                            onChange={(e) => {
                                                setsearch_input(e.target.value);
                                                setOffset(0);
                                                // getItemdata(0, e.target.value);
                                                updateRow(globalIndex, "Link_Name", e.target.value);
                                            }}
                                            value={row.Link_Name || row.Link_Name}
                                        />

                                        <div
                                            ref={dropdownRef}
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                right: 0,
                                                maxHeight: showDropdown_two === globalIndex ? "200px" : "0",
                                                display: showDropdown_two === globalIndex ? '' : 'none',
                                                overflowY: "auto",
                                                background: "white",
                                                border: showDropdown_two === globalIndex ? "1px solid #ccc" : "",
                                                zIndex: 10,
                                            }}
                                        >
                                            {item_list_two?.map((item, idx) => (
                                                <div key={idx}
                                                    className="text-start"
                                                    onClick={() => {
                                                        updateRow(globalIndex, "Link_Name", item.name);
                                                        setsearch_input("");
                                                        setShowDropdown_two(false);

                                                    }}
                                                    style={{
                                                        padding: "8px",
                                                        cursor: "pointer",
                                                        borderBottom: "1px solid #eee",
                                                    }}
                                                >
                                                    <p className="m-0">
                                                        {item.name}
                                                    </p>
                                                    {/* <div style={{ fontSize: '10px' }}>
                                                        {item?.name}, {item?.name}
                                                    </div> */}
                                                </div>

                                            ))}
                                        </div>
                                        {/* <input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={row.item.item_name} /> */}
                                    </td>
                                    <td className="p-0 d-flex justify-content-center"
                                        style={{
                                            border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'quantity' ? '0.3px solid #270b79' : ''
                                        }}>
                                        {row.Link_Title}

                                    </td>

                                    <td className="p-0" style={{ height: '30px', textAlign: 'center' }}>
                                        <span style={{ position: 'relative', top: '4px', height: '30px' }}>
                                            <GetIcon iconName="MdOutlineEdit" size={15} />
                                        </span>
                                    </td>                                    {/* <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={!row.item?.buying_price ? '' : `₹${row.item.buying_price}`} /></td> */}
                                    {/* <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={!row.item?.buying_price ? '' : `₹${row.item.buying_price * row.quantity}`} /></td> */}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className="d-flex pb-2 justify-content-between align-items-center">
                    <div className="d-flex" style={{ gap: '4px' }}>
                        {selectedRows.length > 0 && po_status == '' && (
                            <Button
                                onClick={handleDeleteSelectedRows}
                                className="customdeletebtn "
                                iconName="MdDeleteOutline"
                                iconSize={12}
                            >
                                Delete
                            </Button>
                        )}
                        {/* {selectedRows.length == 0 && po_status == '' && ( */}
                        <Button
                            onClick={handleAddRow}
                            className="Addrowdesign"
                            iconName="FiPlus"
                            iconSize={12}
                            iconWrapperStyle={{ backgroundColor: '#ff8d5c', padding: '1px', display: 'flex' }}
                        >
                            Add Row
                        </Button>
                        {/* )} */}
                        <Button
                            className="createbtn d-flex"
                            style={{ gap: '2px', height: '28px' }}
                            iconName="MdOutlineFileDownload"
                            iconSize={12}
                        >
                            Download
                        </Button>
                    </div>

                    <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
                        <Pagination
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            pageSize={rowsPerPage}
                            totalrecords={rows.length}
                        />
                    </div>

                    <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
                        <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
                            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                        </span>
                    </div>
                </div>
            </div>

            {/* check box section */}
            <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>

                <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
                        <input
                            type="checkbox"
                            checked={formData.is_primary_contact || false}
                            onChange={(e) => {
                                onInputChange('is_primary_contact', e.target.checked);
                            }}
                            className="form-check-input me-2"
                            style={{
                                width: '15px', height: '15px',
                                backgroundColor: formData.isGroupWarehouse ? '#270B79' : 'white',

                                borderColor: "#270B79"
                            }}
                        />
                        Is Primary Contact
                    </label>


                </div>

                <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
                        <input
                            type="checkbox"
                            checked={formData.is_billing_contact || false}
                            onChange={(e) => {
                                onInputChange('is_billing_contact', e.target.checked);
                            }}
                            className="form-check-input me-2"
                            style={{
                                width: '15px', height: '15px',
                                backgroundColor: formData.isGroupWarehouse ? '#270B79' : 'white',

                                borderColor: "#270B79"
                            }}
                        />
                        Is Billing Contact
                    </label>


                </div>
            </div>
            {/* check box section */}


        </div>
    );
};

export default Table3;